<template>
    <div class="page-wrapper">
        <div class="page-section">
            <div class="cg-crumb">
                <btn-back />
                <span class="item">订单管理</span>
                <em class="gap">/</em>
                <span class="item">清算详情</span>
            </div>
            <div class="cg-main-title">清算详情</div>
            <div class="header-handle-box">
                <h3 class="state stateImgBox">
                    清算订单号：{{lDetail.order_number}}
                    <span style="margin-left: 20px;">{{liquidationState[lDetail.order_state]}}</span>
                    <img src="../../../assets/img_qingsuanwancheng.png" alt="" class="stateImg" v-if="lDetail.order_state==6">
                </h3>
                <div class="btns">
                    <button class="cg-btn big red-border" @click="openReturnGoodsModal" v-if="lDetail.order_state&&('24'.search(lDetail.order_state)>-1) ">填写退货数量</button>
                </div>
            </div>
            <div style="padding:0 5px;">
                <div class="newBigTitle">清算记录</div>
                <div class="newSubTitle">特别说明：数据需平台方操作后更新</div>
            </div>
            
        </div>
        
        <!-- 销售商付款记录 start-->
        <div class="page-section newStyle " style="margin-top:-26px"  v-if="billList_final.chargeBalance">
            <ul class="time-line">
                <li class="item" >
                    <div class="item-tail"></div>
                    <div class="item-content">
                        <div class="item-tit">
                            <div class="bigTitle">
                                <span v-if="billList_final.rest_pay_amount_subConfirm>0"> 您还需支付 <span class="redNumber">{{billList_final.rest_pay_amount_subConfirm}} </span> 元</span>
                                <span v-if="!billList_final.chargeBalance||billList_final.chargeBalance<=0">本次清算订单已付清并且平台已全部确认</span>
                                <span v-if="billList_final.rest_pay_amount_subConfirm<=0&&billList_final.chargeBalance>0">您已全部付款，请等待平台确认收款</span>
                                
                                <button  style="margin-left:20px;vertical-align: top;" class="cg-btn red" @click="liquidationPay(billList_final)" 
                                v-if="billList_final.chargeBalance>0&&lDetail.order_state&&('2345'.search(lDetail.order_state)>-1)">清算付款</button>
                            </div>
                            <div class="subTitle" v-if="billList_final.order_pay_amount>0">平台已确认收到金额：{{billList_final.order_pay_amount}}元</div>
                            <div class="subTitle" v-if="billList_final.amountToBeConfirmed>0">待平台确认金额：{{billList_final.amountToBeConfirmed}}元</div>
                        </div>
                        <div class="item-box">
                            <ul class="sub-time-line">
                                <li class="sub-item" v-for="(pay_ele, index) in billList_final.liquidateOrderPaymentList" :key="index">
                                    <div class="pdb-12">
                                        <span class="title" style=" display: inline-block;min-width:450px;">
                                            <span class="time leftBlock">{{pay_ele.order_submit_time}}</span>
                                            销售商上传了付款凭证，支付了{{pay_ele.order_payment_amount}}元
                                        </span>
                                        <el-tag type="success" v-if="pay_ele.order_state == 'y'">平台已确认</el-tag>
                                        <el-tag type="warning" v-if="pay_ele.order_state == 'p'">待平台确认</el-tag>
                                        <el-tag type="danger" v-if="pay_ele.order_state == 'n'">平台已拒绝</el-tag>
                                    </div>
                                    <div class="pdb-12">
                                        <template v-for="(img_ele, img_index) in pay_ele.imageFiles">
                                            <el-image :key="img_index" v-if="img_ele" class="img" :src="img_ele" fit="cover"
                                                :preview-src-list="pay_ele.imageFiles"></el-image>
                                        </template>
                                        <span v-if="pay_ele.order_transfer_memo" class="pay-info grey">说明：{{pay_ele.order_transfer_memo}}</span>
                                    </div>
                                </li>
                                <li class="sub-item">
                                    <div class="pdb-12">
                                        <div class="title">
                                            <span class="time leftBlock"> {{lDetail.liquidateDataInfo && lDetail.liquidateDataInfo.order_submit_time}}</span>
                                            <div class="rightBlock">
                                                <div v-if="!lDetail.liquidateDataInfo.orderRefundQuantity">清算前已全部核销，不需要退货</div>
                                                <div v-if="lDetail.liquidateDataInfo.orderRefundQuantity>0">
                                                    <span>供应商已同意了您发起的{{lDetail.liquidateDataInfo.orderRefundQuantity}}件退货请求</span>
                                                </div>
                                                <div v-if="lDetail.liquidateDataInfo.orderRefundQuantity>0">
                                                    <span>退货后自动核销：{{lDetail.liquidateDataInfo.autoEstablish}}件</span>
                                                </div>
                                                <div v-if="billList_final.dealerSumPay&&Number(billList_final.dealerSumPay)>0">
                                                    <span>本次清算账单：</span>
                                                    <span class="">
                                                        {{ billList_final.order_arrears_amount }} +
                                                        {{lDetail.liquidateDataInfo.autoEstablish}} x {{lDetail.item_order_price | tablePrice}}
                                                        x
                                                        {{lDetail.supplier_rate}}% =
                                                        {{ billList_final.dealerSumPay }}元
                                                    </span>
                                                </div>
                                                <div v-if="billList_final.dealerSumPay&&Number(billList_final.dealerSumPay)>0">
                                                    <span class="val">退货前您还需提交发起支付金额：{{ billList_final.order_arrears_amount }} 元</span>
                                                </div>
                                                <div v-else>清算前已全部付清</div>
                                               
                                            </div>
                                        </div>
                                    </div>
                                </li>

                            </ul>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <!-- 销售商付款记录 end -->
        <!-- 平台付款记录 start-->
        <div class="page-section newStyle"  v-if="platform_billList_final.chargeBalance">
            <ul class="time-line">
                <li class="item" >
                    <div class="item-tail"></div>
                    <div class="item-content">
                        <div class="item-tit">
                            <div class="bigTitle">
                                <span v-if="platform_billList_final.chargeBalance>0">平台需要向供应商支付 <span class="redNumber"> {{platform_billList_final.chargeBalance}}</span> 元</span>
                                <span v-if="!platform_billList_final.chargeBalance||platform_billList_final.chargeBalance==0">平台结款已完成</span>
                            </div>
                            <div class="subTitle">当前供应商已确认金额总计{{platform_billList_final.sumPay||0}}元</div>
                            <div class="subTitle">待供应商确认金额总计{{platform_billList_final.amountToBeConfirmed||0}}元</div>
                        </div>
                        <div class="item-box">
                            <ul class="sub-time-line" v-if="platform_billList_final.liquidateOrderPaymentList && platform_billList_final.liquidateOrderPaymentList.length > 0">
                                <li class="sub-item" v-for="(pay_ele, index) in platform_billList_final.liquidateOrderPaymentList" :key="index">
                                    <div class="pdb-12">
                                        <span class="title" style="display: inline-block;min-width: 450px;">
                                            <span class="time">{{pay_ele.order_submit_time}}</span>
                                            平台上传了付款凭证，支付了{{pay_ele.order_payment_amount}}元
                                        </span>
                                        <el-tag type="success" v-if="pay_ele.order_state == 'y'">供应商已确认</el-tag>
                                        <el-tag type="info" v-if="pay_ele.order_state == 'p'">待供应商确认</el-tag>
                                        <el-tag type="danger" v-if="pay_ele.order_state == 'n'">供应商已拒绝</el-tag>
                                    </div>
                                    <div class="pdb-12">
                                        <template v-for="(img_ele, img_index) in pay_ele.imageFiles">
                                            <el-image :key="img_index" v-if="img_ele" class="img" :src="img_ele" fit="cover"
                                                :preview-src-list="pay_ele.imageFiles"></el-image>
                                        </template>
                                        <span v-if="pay_ele.order_transfer_memo" class="pay-info grey">说明：{{pay_ele.order_transfer_memo}}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <!-- 平台付款记录 end -->
        
        <div class="page-section" v-if="billList_apply.length > 0">
          <div class="cg-mod-title mgt-0">平台应向销售商打款账单</div>
          <ul class="time-line">
            <li class="item" v-for="(item, index) in billList_apply" :key="index">
              <div class="item-tail"></div>
              <div class="item-node"></div>
              <div class="item-content">
                <div class="item-tit">
                  <strong class="item-tit-strong">申请额度通过，平台应向您支付的第{{billList_apply.length - index}}个账单</strong>
                  <span class="item-tit-during">（审核通过账单生成时间：{{item.order_submit_time}}）</span>
                </div>
                <div class="item-sum-data">
                  <div >本次您申请总金额：{{item.order_bill_amount}} 元</div>
                  <div v-if="item.amountToBeConfirmed>0">平台已支付未被确认金额：（待您确认）{{item.amountToBeConfirmed}}  元</div>
                  <div v-if="item.remainAmount>0">平台还需支付总金额：<span class="red">{{item.remainAmount}} 元</span></div>
                </div>
                <div class="item-box">
                  <ul class="sub-time-line">
                    <template v-if="item.orderPaymentList">
                      <li class="sub-item" v-for="(child, pay_i) in item.orderPaymentList" :key="pay_i">
                        <div class="pdb-12">
                          <span class="title">
                            <span class="time">{{child.order_submit_time}}</span>
                           平台上传了付款凭证，打款了{{child.order_payment_amount}}元
                          </span>
                          <el-tag type="success" v-if="child.order_state == 'y'">已确认收到</el-tag>
                          <el-tag type="danger" v-if="child.order_state == 'n'">您已驳回</el-tag>
                          
                          <button class="cg-btn big red" v-if="child.order_state == 'p'" @click="openCheckApplyPay(child)">待您确认</button>
                        </div>
                        <div class="pdb-12">
                         <template v-for="(img_ele, img_index) in child.imageFiles">
                            <el-image :key="img_index" v-if="img_ele" class="img" :src="img_ele" fit="cover"
                              :preview-src-list="child.imageFiles"></el-image>
                          </template>
        
                          <span v-if="child.order_payment_memo" class="pay-info grey">
                            说明：{{child.order_payment_memo}}
                          </span>
                        </div>
                      </li>
                    </template>
        
                    <!-- <li class="sub-item">
                      <div class="pdb-6">
                        <span class="time">{{item.order_submit_time}}</span>
                        系统依据平台规则向销售商发布了付款账单
                      </div>
                      <div class="grey pdb-12">
                        销售商本次付款周期期间明细账单：<br>
                        本周期内已核销总数：件
                        <br>
                        <template >
                          剩余未核销数： 件 <br>
                        </template>
                        销售商需支付金额：<span class="green">{{item.order_bill_amount}} 元</span>
                      </div>
                    </li>
                    <li class="sub-item">
                      <div class="pdb-6">
                        <span class="time">tine</span>
                        销售商第1次核销
                      </div>
                      <div class="grey pdb-12">
                        核销前未核销总数666 件，核销 666 件，剩余未核销
                       666件。<br>
                        核销应付款：666
                        <span class="green">666元</span>
                      </div>
                    </li> -->
                  </ul>
                </div>
              </div>
            </li>
          </ul>
        </div>
        
        
        <div class="page-section" v-if="applyLists.length > 0">
            <div class="cg-mod-title mgt-0">申请记录</div>
            <ul class="time-line">
                <li class="item" v-for="(item, index) in applyLists" :key="index">
                    <div class="item-tail"></div>
                    <div class="item-node"></div>
                    <div class="item-content">
                        <div class="item-tit">
                            销售商第{{applyLists.length - index}}次申请 ({{item.request_submit_time}})
                        </div>
                        <div class="item-box">
                            <div class="grey">
                                <div style="display: inline-block;width: 200px;">申请金额：{{item.request_amount}} 元</div>
                                <el-tag type="success" v-if="item.request_state == 'y'">平台已确认</el-tag>
                                
                                <el-tag type="danger" v-if="item.request_state == 'p'">待平台审核</el-tag>
                                
                                <el-tag type="info" v-if="item.request_state == 'n'">平台已驳回</el-tag>
                                <span v-if="item.request_state == 'n'&&item.request_last_update_memo">(驳回理由：{{item.request_last_update_memo}})</span>
                                <br>
                                申请备注：{{item.request_content}} <br>
                               <template v-for="(img_ele, img_index) in item.imgArr">
                                    <el-image
                                      :key="img_index"
                                      v-if="img_ele"
                                      class="img"
                                      :src="img_ele"
                                      fit="cover"
                                      :preview-src-list="item.imgArr"
                                  ></el-image>
                                </template>
                                
                               
                                
                            </div>    
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="page-section" v-if="returnLists.length > 0">
            <div class="cg-mod-title mgt-0">退货记录</div>
            <ul class="time-line">
                <li class="item" v-for="(item, index) in returnLists" :key="index">
                    <div class="item-tail"></div>
                    <div class="item-node"></div>
                    <div class="item-content">
                        <div class="item-tit">
                            <span class="title">
                                {{item.order_submit_time}}<span class="mr10"></span>
                                您第{{returnLists.length - index}}次填写退货数量： {{item.return_quantity}} 件
                            </span>
                            <span class="mr10"></span>
                            <el-tag type="success" v-if="item.order_state == 'y'">供应商已确认</el-tag>
                            <el-tag type="danger" v-if="item.order_state == 'n'">供应商已拒绝</el-tag>
                            <el-tag type="warning" v-if="item.order_state == 'p'">待供应商审核</el-tag>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="page-section">
            <div class="basic-wrap clearfix">
                <div class="img-wrap">
                    <el-image class="img" :src="lDetail.productMainImageFile" fit="cover" :preview-src-list="[lDetail.productMainImageFile]"></el-image>
                </div>
                <div class="basic-info">
                    <el-row>
                        <div class="line">
                            <span class="lab">商品名称： </span>
                            <span class="val tit">{{lDetail.item_name}}</span>
                        </div>
                        <div class="line">
                            <span class="lab">商品款号： </span>
                            <span class="val tit">{{lDetail.item_style_number}}</span>
                        </div>
                        <div class="line">
                            <span class="lab">供应商： </span>
                            <span class="val tit">{{lDetail.supplierName}}</span>
                        </div>
                        <div class="line">
                            <span class="lab">销售商： </span>
                            <span class="val tit">{{lDetail.dealerName}}</span>
                        </div>
                        <div class="line">
                            <span class="lab">当前定价： </span>
                            <span class="val tit">{{lDetail.item_order_price | tablePrice}} 元</span>
                        </div>
                    </el-row>
                </div>
            </div>
        </div>
        <div class="page-section">
            <div class="cg-mod-title mgt-0">清算清单（包含的下单订单列表）</div>
            <div class="take-order-table clearing">
                <table class="table">
                  <tr class="th">
                    <th width>下单订单号</th>
                    <th width>下单总数</th>
                    <th width>
                      核销对应
                      <br />价格(元)
                    </th>
                    <th width>
                      已核销
                      <br />件数
                    </th>
                    <th width>
                      未核销
                      <br />件数
                    </th>
                    <th width>
                      已出账单需<br />支付额(元)
                    </th>
                    <th width>
                      平台已确认<br />金额(元)
                    </th>
                    <th width>已出账单欠款(元)</th>
                  </tr>
                  <tr v-for="(item, index) in lDetail.orderPurchaseList" :key="index">
                    <td>{{item.order_number}}</td>
                    <td>{{item.order_purchase_quantity}}</td>
                    <td>{{item.item_order_price | tablePrice}}</td>
                    <td>{{item.sumEstablishQuantity}}</td>
                    <td>{{item.unEstablishQuantity}}</td>
                    <td>{{item.needPay}}</td>
                    <td>{{item.sumPay}}</td>
                    <td>{{item.debtMoney}}</td>
                  </tr>
                </table>
            </div>
        </div>
        <returnmodal v-show="isShowReturnModal" :info="currentReturnGoodsModalInfo" @close="closeReturnModal" @success="closeReturnModalAndSuccess"></returnmodal>
        <paymodal :isLiquidation="true" v-show="isShowPayModal" :info="currentPayModalInfo" @close="closePayModal"  @success="closePayModalAndSuccess"></paymodal>
        <checkApplyPayModal :isLiquidation="true" v-show="isShowCheckApplyPayModal" :info="currentCheckApplyPayObj" @close="closeCheckApplyPayModal" @success="closeCheckApplyPayModalAndSuccess"></checkApplyPayModal>
    </div>
</template>

<script>
    import {
        launchLiquidate,
        liquidateInfo,
        confirmRefundQuantity,
        getBillList
    } from '../../../api/supplier'
    import {
        returnGoodInfo,
        returnGoodsInfo,applicationList
    } from '../../../api/dealer'
    import returnmodal from '../../../components/returnmodal'
    import {
        accMul,
        accDiv,
        accSub,computeSub
    } from '../../../utils/tools'
    import {
        liquidationState
    } from '../../../utils/word_dealer'
    import paymodal from '../../../components/paymodal'
    import checkApplyPayModal from '../../../components/checkApplyPayModal'
    export default {
        data() {
            return {
                returnLists: [], //退货明细
                liquidationState: liquidationState,
                lDetail: {
                    dealerName: '',
                    dealer_user_id: '',
                    itemFeeSplitting: '',
                    item_id: '',
                    item_name: '',
                    item_order_price: '',
                    item_style_number: '',
                    orderPurchaseList: [],
                    order_id: '',
                    order_number: '',
                    order_state: '',
                    productMainImageFile: '',
                    supplierName: '',
                    supplier_user_id: '',
                },
                //弹框的传参
                currentReturnGoodsModalInfo: {
                    liquidateOrderId: '',
                    itemId: '',
                    haveCheckNumber: '?',
                    leftCheckNumber: '?',

                },
                // 确认退货数量弹框
                isShowReturnModal: false,
                isShowPayModal: false,
                currentPayModalInfo: {
                    orderId: "",
                    itemId: "",
                    liquidateOrderId: '',
                    haveEstablishTotal: "",
                    leftEstablishTotal: "",
                    totalEstablish: "",
                    supplierUserId: "",
                    establishOrderInfo: '',
                    order_bill_amount: '',
                    chargeBalance: '',
                    allLeftMoney: '',
                    order_pay_amount: '',
                    nowLeftMoney: '',
                    historyLeftMoney: '',
                    amountToBeConfirmed:'',
                    rest_pay_amount_subConfirm:'',
                    billId: '',
                },
                // 账单列表
                billList_dealer: [],
                billList_platform: [],
                payLists: [],

                // 确认销售商付款
                billList_final_list: [],
                billList_final: {},

                // 确认平台结款
                platform_billList_final_list: [],
                platform_billList_final: {},
                
                applyLists:[],
                billList_apply:[],
                
                isShowCheckApplyPayModal:false,
                currentCheckApplyPayObj:{}




            }
        },
        created() {
            this.initPage()
        },
        computed: {
            imgPrev() {
                return process.env.VUE_APP_IMG_PREV
            }
        },
        components: {
            returnmodal,
            paymodal,checkApplyPayModal
        },
        methods: {
            initPage() {
                this.getLiquidationDetail()
                this.getReturnGoodInfo()
                this.returnGoodsInfo()
                this.getBillList()
                this.getBillList_plat()
                this.getBillList_apply()
                this.getApplyList()
            },
            openCheckApplyPay(list){
                this.isShowCheckApplyPayModal=true
                this.currentCheckApplyPayObj=list
                this.currentCheckApplyPayObj.orderNumberShow=list.order_number
            },
            getApplyList(){
                
                this.applyLists=[]
                applicationList({
                    liquidateOrderId: this.$route.query.orderId
                }).then(res=>{
                    if(res.errorCode==200){
                        this.applyLists=res.data.map(function(item,index){
                            console.log(item)
                            item.imgArr=item.image_file ? item.image_file.split(',').map(ele => ele ? process.env.VUE_APP_IMG_PREV + ele : '') : []
                            return item
                        })
                        
                    }else{
                         // this.$message.error(res.errorMsg)
                    }
                })
            },
            getBillList_apply(){
                let _this = this
                getBillList({
                    billType: 6,
                    liquidateOrderId: this.$route.query.orderId
                }).then(res => {
                    console.log(res);
                    if (res.errorCode == 200) {
                        this.billList_apply = res.data.map(element => {
                          return {
                            ...element,
                            orderPaymentList: element.liquidateOrderPaymentList ? element.liquidateOrderPaymentList.map(item => {
                              return {
                                ...item,
                                imageFiles: item.image_file ? item.image_file.split(',').map(ele => ele ? process.env.VUE_APP_IMG_PREV+
                                  ele : '') : []
                              }
                            }) : []
                          }
                        });
                    } else {
                
                    }
                }).catch(err => {
                    console.log(err)
                })
            },
            getBillList_plat() {
                let _this = this
                getBillList({
                    billType: 4,
                    liquidateOrderId: this.$route.query.orderId
                }).then(res => {
                    console.log(res);
                    if (res.errorCode == 200) {
                        this.platform_billList_final_list = res.data.map(element => {
                            return {
                                ...element,
                                order_arrears_amount: (+element.order_arrears_amount).toFixed(
                                    2
                                ),
                                order_bill_amount: (+element.order_bill_amount).toFixed(2),
                                dealerSumPay: (
                                    element.order_arrears_amount + element.order_bill_amount
                                ).toFixed(2),
                                // autoEstablish: order_content.autoEstablish,
                                // sumOrderQuantity: order_content.sumOrderQuantity,
                                // sumOrderEstablish: order_content.sumOrderEstablish,
                                // orderRefundQuantity: order_content.orderRefundQuantity,
                                order_pay_amount: (+element.order_pay_amount).toFixed(2),
                                sum_pay_amonut: (element.order_arrears_amount + element.order_bill_amount)
                                    .toFixed(2),
                                chargeBalance: element.chargeBalance ?
                                    (+element.chargeBalance > 0 ?
                                        +element.chargeBalance :
                                        0
                                    ).toFixed(2) : (
                                        element.order_arrears_amount + element.order_bill_amount
                                    ).toFixed(2),
                                liquidateOrderPaymentList: element.liquidateOrderPaymentList ?
                                    element.liquidateOrderPaymentList.map(item => {
                                        return {
                                            ...item,
                                            imageFiles: item.image_file ?
                                                item.image_file
                                                .split(",")
                                                .map(ele => (ele ? process.env.VUE_APP_IMG_PREV +
                                                    ele : "")) : [],
                                            restPay: (element.chargeBalance -
                                                item.order_payment_amount >
                                                0 ?
                                                element.chargeBalance - item.order_payment_amount :
                                                0
                                            ).toFixed(2)
                                        };
                                    }) : []
                            };
                        });
                        this.platform_billList_final =
                            this.platform_billList_final_list[0] || {};

                    } else {

                    }
                }).catch(err => {
                    console.log(err)
                })
            },
            // 获取账单信息  1 - 销售商  2 - 平台
            getBillList() {
                let _this = this
                getBillList({
                    billType: 3,
                    // orderPurchaseNumber: this.orderDetail.order_number,
                    liquidateOrderId: this.$route.query.orderId
                }).then(res => {
                    console.log(res);
                    if (res.errorCode == 200) {
                        console.log("付款历史记录===============")
                        console.log(res.data)
                        // _this.payLists = res.data.map(function(item, index) {
                        //     let buffer = {}
                        //     console.log(item)
                        //     buffer.historyLeftMoney = Number(item.order_arrears_amount || 0)
                        //     buffer.nowLeftMoney = Number(item.order_bill_amount || 0)
                        //     buffer.allLeftMoney = buffer.historyLeftMoney + buffer.nowLeftMoney
                        //     buffer.order_pay_amount = Number(item.order_pay_amount || 0)
                        //     buffer.chargeBalance = buffer.allLeftMoney

                        //     buffer.order_submit_time = item.order_submit_time
                        //     buffer.order_id = item.order_id
                        //     buffer.order_state = item.order_state
                        //     buffer.liquidateOrderPaymentList = item.liquidateOrderPaymentList
                        //     console.log(buffer)
                        //     return buffer
                        // })
                        this.billList_final_list = res.data.map(element => {
                            let order_content = {}
                            try {
                                order_content = JSON.parse(this.lDetail.liquidateDataInfo.order_content)
                            } catch (error) {

                            }
                            let chargeBalaceNumber=element.chargeBalance ?(+element.chargeBalance > 0 ?+element.chargeBalance :0).toFixed(2) 
                            : (element.order_arrears_amount + element.order_bill_amount).toFixed(2)
                            return {
                                ...element,
                                order_arrears_amount: (+element.order_arrears_amount).toFixed(
                                    2
                                ),
                                order_bill_amount: (+element.order_bill_amount).toFixed(2),
                                dealerSumPay: (
                                    element.order_arrears_amount + element.order_bill_amount
                                ).toFixed(2),
                                autoEstablish: order_content.autoEstablish,
                                sumOrderQuantity: order_content.sumOrderQuantity,
                                sumOrderEstablish: order_content.sumOrderEstablish,
                                orderRefundQuantity: order_content.orderRefundQuantity,
                                order_pay_amount: (+element.order_pay_amount).toFixed(2),
                                chargeBalance:chargeBalaceNumber,
                                rest_pay_amount_subConfirm:computeSub(chargeBalaceNumber,element.amountToBeConfirmed),
                                liquidateOrderPaymentList: element.liquidateOrderPaymentList ?
                                    element.liquidateOrderPaymentList.map(item => {
                                        return {
                                            ...item,
                                            imageFiles: item.image_file ?
                                                item.image_file
                                                .split(",")
                                                .map(ele => (ele ? process.env.VUE_APP_IMG_PREV +
                                                    ele : "")) : [],
                                            restPay: (element.chargeBalance -
                                                item.order_payment_amount >
                                                0 ?
                                                element.chargeBalance - item.order_payment_amount :
                                                0
                                            ).toFixed(2)
                                        };
                                    }) : []
                            };
                        });
                        this.billList_final = this.billList_final_list[0] || {};

                    } else {

                    }
                }).catch(err => {
                    console.log(err)
                })
            },
            closePayModal() {
                this.isShowPayModal = false
            },
            closePayModalAndSuccess() {
                this.isShowPayModal = false
                //刷新页面
                this.initPage()
            },
            closeReturnModal() {
                this.isShowReturnModal = false
            },
            closeReturnModalAndSuccess() {
                this.isShowReturnModal = false
                this.initPage()
            },
            closeCheckApplyPayModal(){
                this.isShowCheckApplyPayModal=false
            },
            closeCheckApplyPayModalAndSuccess(){
                this.isShowCheckApplyPayModal=false
                //刷新页面
                this.initPage()
                
            },
            // 获取清算详情
            getLiquidationDetail() {
                liquidateInfo({
                    liquidateOrderId: this.$route.query.orderId
                }).then(res => {
                    console.log(res)
                    if (res.errorCode == 200) {
                        this.lDetail = res.data[0];
                        this.lDetail.productMainImageFile = this.lDetail.productMainImageFile ? process.env.VUE_APP_IMG_PREV +
                            this.lDetail.productMainImageFile : ''
                        this.lDetail.liquidateDataInfo = this.lDetail.liquidateDataInfo || {}
                        try {
                            let strObj = {}
                            if(this.lDetail.liquidateDataInfo&&this.lDetail.liquidateDataInfo.order_content){
                                 strObj = JSON.parse(this.lDetail.liquidateDataInfo.order_content)
                            }
                            this.lDetail.liquidateDataInfo.autoEstablish = Number(strObj.autoEstablish)
                            this.lDetail.liquidateDataInfo.sumOrderQuantity = Number(strObj.sumOrderQuantity)
                            this.lDetail.liquidateDataInfo.sumOrderEstablish = Number(strObj.sumOrderEstablish)
                            this.lDetail.liquidateDataInfo.orderRefundQuantity = Number(strObj.orderRefundQuantity)
                            console.log(this.lDetail)
                            // this.currentPayModalInfo.orderId=this.lDetail.order_id
                            this.currentPayModalInfo.itemId = this.lDetail.item_id
                            this.currentPayModalInfo.liquidateOrderId = this.lDetail.order_id
                            this.currentPayModalInfo.haveEstablishTotal = this.lDetail.liquidateDataInfo.sumOrderEstablish
                            this.currentPayModalInfo.totalEstablish = this.lDetail.liquidateDataInfo.sumOrderQuantity
                            this.currentPayModalInfo.leftEstablishTotal = this.lDetail.liquidateDataInfo.sumOrderQuantity -
                            this.lDetail.liquidateDataInfo.sumOrderEstablish
                            this.currentPayModalInfo.autoEstablish = this.lDetail.liquidateDataInfo.autoEstablish
                            this.currentPayModalInfo.returnNumber = this.lDetail.liquidateDataInfo.orderRefundQuantity
                            this.currentPayModalInfo.supplierUserId = this.lDetail.supplier_user_id
                            // establishOrderInfo:'',

                        } catch (err) {

                        }
                        
                        // 
                        if (this.lDetail.orderPurchaseList) {
                          this.lDetail.orderPurchaseList = this.lDetail.orderPurchaseList.map(item => {
                            // 欠款
                            let debtMoney = computeSub(item.needPay - item.sumPay)
                            // 核销数 ，未核销数
                            let sumEstablishQuantity, unEstablishQuantity
                            if (item.sumEstablishQuantity == undefined || item.sumEstablishQuantity === '') {
                                sumEstablishQuantity = '/'
                                unEstablishQuantity = '/'
                            } else {
                                sumEstablishQuantity = item.sumEstablishQuantity
                                unEstablishQuantity = item.order_purchase_quantity - item.sumEstablishQuantity
                            }
                            return {
                              ...item,
                              debtMoney,
                              sumEstablishQuantity,
                              unEstablishQuantity
                            }
                            
                          })
                        }
                        
                        this.lDetail.supplier_rate = this.lDetail.itemFeeSplitting
                            ? accMul(this.lDetail.itemFeeSplitting.split(",")[1], 100)
                            : "";
                        this.lDetail.dealer_rate = this.lDetail.itemFeeSplitting
                            ? accMul(this.lDetail.itemFeeSplitting.split(",")[0], 100)
                            : "";


                    }
                }).catch(err => {
                    console.log(err)
                })
            },
            // 填写退货信息
            openReturnGoodsModal() {
                this.isShowReturnModal = true
                this.currentReturnGoodsModalInfo.liquidateOrderId = this.$route.query.orderId
            },
            // 发起清算
            // startLiquidation() {
            //     this.$confirm('您确定发起清算吗?', '提示', {
            //         confirmButtonText: '确定',
            //         cancelButtonText: '取消',
            //         type: 'warning'
            //     }).then(() => {
            //         this.launchLiquidate(2)
            //     })
            // },
            closeLiquidation() {
                this.$confirm('您确定取消/关闭清算吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.launchLiquidate(1)
                })
            },
            liquidationPay(list) {
                console.log(list)
                this.currentPayModalInfo.order_pay_amount = list.order_pay_amount||0
                this.currentPayModalInfo.nowLeftMoney = Number(list.order_bill_amount || 0)
                this.currentPayModalInfo.historyLeftMoney = Number(list.order_arrears_amount || 0)
                this.currentPayModalInfo.allLeftMoney = this.currentPayModalInfo.nowLeftMoney + this.currentPayModalInfo
                    .historyLeftMoney

                this.currentPayModalInfo.chargeBalance = list.chargeBalance||0
                this.currentPayModalInfo.amountToBeConfirmed = list.amountToBeConfirmed||0
                this.currentPayModalInfo.rest_pay_amount_subConfirm = list.rest_pay_amount_subConfirm||0
                
                this.currentPayModalInfo.billId = list.order_id
                console.log('this.currentPayModalInfo', this.currentPayModalInfo)
                this.isShowPayModal = true
            },

            // 发起清算 api
            launchLiquidate(type) {
                launchLiquidate({
                    liquidateOrderId: this.$route.query.orderId,
                    orderState: type,

                }).then(res => {
                    console.log(res)
                    if (res.errorCode == 200) {
                        this.$message.success(res.errorMsg || '操作成功')
                        this.initPage()
                    } else {
                        this.$message.error(res.errorMsg || '操作是失败')
                    }
                }).catch(err => {
                    console.log(err)
                })
            },

            // 获取退货数量信息
            getReturnGoodInfo() {
                returnGoodInfo({
                    liquidateOrderId: this.$route.query.orderId,
                }).then(res => {
                    console.log(res)
                    if (res.errorCode == 200) {
                        this.returnLists = res.data
                    } else {
                        this.returnLists = []
                    }
                }).catch(err => {
                    console.log(err)
                })
            },
            //  获取总下单数和累计核销数
            returnGoodsInfo() {
                returnGoodsInfo({
                    liquidateOrderId: this.$route.query.orderId,
                }).then(res => {
                    console.log(res)
                    if (res.errorCode == 200) {
                        let total = res.data.getSumOrder ? Number(res.data.getSumOrder) : 0
                        let have = res.data.getSumOrderEstablish ? Number(res.data.getSumOrderEstablish) : 0
                        this.currentReturnGoodsModalInfo.haveCheckNumber = have
                        this.currentReturnGoodsModalInfo.leftCheckNumber = total - have
                    } else {}
                }).catch(err => {
                    console.log(err)
                })
            },


            //确认退货数量
            confirmRefundQuantity() {
                confirmRefundQuantity({
                    liquidateOrderId: this.$route.query.orderId,
                    orderState: 'p'
                }).then(res => {
                    console.log(res)
                    if (res.errorCode == 200) {
                        this.$message.success(res.errorMsg || '操作成功')
                    } else {
                        this.$message.error(res.errorMsg || '操作是失败')
                    }
                }).catch(err => {
                    console.log(err)
                })
            },



            // 获取订单数据
            // getReserverOrderInfo() {
            //     getReserverOrderInfo({
            //         orderPurchaseNumber: this.$route.query.orderPurchaseNumber
            //     }).then(res => {
            //         console.log(res)
            //         if (res.errorCode == 200) {
            //             let detail = res.data[0]
            //             this.orderState = detail.order_state
            //             this.orderDetail = detail
            //             this.imgUrl = process.env.VUE_APP_IMG_PREV + detail.productMainImageFile
            //             this.srcList.push(this.imgUrl)

            //             this.orderDetail.supplier_rate = this.orderDetail.itemFeeSplitting ? accMul(this.orderDetail
            //                 .itemFeeSplitting.split(',')[1], 100) : ''
            //             this.orderDetail.dealer_rate = this.orderDetail.itemFeeSplitting ? accMul(this.orderDetail
            //                 .itemFeeSplitting.split(',')[0], 100) : ''

            //             let B_order_state = ''
            //             if (detail.order_state == 2 || detail.order_state == 3) {
            //                 if (detail.sumEstablishQuantity == 0) {
            //                     B_order_state = '从未核销'
            //                 } else if (detail.sumEstablishQuantity < detail.order_purchase_quantity) {
            //                     B_order_state = '部分核销'
            //                 } else if (detail.sumEstablishQuantity == detail.order_purchase_quantity) {
            //                     B_order_state = '全部核销'
            //                 }
            //             }
            //             this.orderTakedStateText = B_order_state
            //             try {
            //                 let group = JSON.parse(detail.order_content)
            //                 let arr = group.group
            //                 this.orderSizeColorArr = arr || []
            //                 console.log(this.orderSizeColorArr)
            //             } catch (error) {
            //                 console.log(error)
            //                 this.orderSizeColorArr = []
            //             }

            //             if (detail.reserverOrderInfoList && detail.reserverOrderInfoList.length > 0) {
            //                 this.historyLockOrderList = detail.reserverOrderInfoList.map(item => {
            //                     let group = []
            //                     try {
            //                         let order_content = JSON.parse(item.order_content)
            //                         group = order_content.group
            //                     } catch (error) {
            //                         console.log(error)
            //                     }
            //                     return {
            //                         ...item,
            //                         group
            //                     }
            //                 })
            //             }
            //             console.log(this.historyLockOrderList)

            //             this.getOrderEstablish(detail.order_id)

            //         }
            //     }).catch(err => {
            //         console.log(err)
            //     })
            // },

            // 获取核销数据
            getOrderEstablish(orderId) {
                getOrderEstablish({
                    orderId
                }).then(res => {
                    console.log(res)
                    if (res.errorCode == 200) {
                        let unitPrice, supplierRate, sumMoney
                        unitPrice = this.orderDetail.item_order_price
                        supplierRate = this.orderDetail.itemFeeSplitting ? this.orderDetail.itemFeeSplitting.split(
                            ',')[1] : ''


                        this.checkSaleHistory = res.data.map(item => {
                            let quantityObj = JSON.parse(item.order_content)
                            try {
                                let s1 = accMul(unitPrice, quantityObj.orderEstablishQuantity)
                                let s2 = accMul(s1, supplierRate)
                                sumMoney = s2.toFixed(2)
                            } catch (error) {
                                sumMoney = '--'
                            }
                            return {
                                ...item,
                                orderEstablishQuantity: quantityObj.orderEstablishQuantity,
                                beforeOrderQuantity: quantityObj.beforeOrderQuantity,
                                restQuantity: quantityObj.beforeOrderQuantity - quantityObj.orderEstablishQuantity,
                                unitPrice: unitPrice,
                                supplierRate: accMul(Number(supplierRate), 100),
                                sumMoney: sumMoney
                            }
                        })
                    }
                }).catch(err => {
                    console.log(err)
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .stateImgBox{
        position: relative;
        .stateImg{height: 100px; position: absolute; vertical-align: middle;top:-35px; margin-left: 50px;}
    }
    .img {
        width: 100px;
        height: 100px;
    }

    .page-wrapper {
        min-width: 1030px;
    }

    .test-btns {
        position: absolute;
        right: 10px;
        top: 10px;
    }

    .page-section {
        padding: 24px 24px;
        background: #fff;
        margin-bottom: 16px;
    }

    .header-handle-box {
        min-width: 980px;
        box-sizing: border-box;
        margin-top: 24px;
        border: 1px solid #e6e6e6;
        background: #fafafa;
        padding: 40px 80px;

        .state {
            font-size: 20px;
            color: #333;
            font-weight: 500;

            &.red {
                color: #F81D22;
            }
        }

        .btns {
            .cg-btn {
                margin-right: 20px;
                margin-top: 40px;
            }
        }

        .tip {
            margin-top: 14px;
            height: 20px;
            font-size: 14px;
            color: rgba(51, 51, 51, 0.6);
            line-height: 20px;
        }

        .tip-small {
            margin-left: 8px;
            height: 20px;
            font-size: 14px;
            color: rgba(51, 51, 51, 0.6);
            font-size: normal;
            line-height: 20px;
        }
    }

    .basic-info {
        &.mgt-24 {
            margin-top: 24px;
        }

        &.mgt-40 {
            margin-top: 40px;
        }

        .line {
            padding-bottom: 16px;
            font-size: 14px;
            line-height: 22px;

            .lab {
                color: rgba(0, 0, 0, 0.85);
            }

            .val {
                color: rgba(0, 0, 0, 0.65);
            }

            &.blue .lab,
            &.blue .val {
                color: #1890FF
            }

            .green {
                color: #52C41A;
            }

            .text-btn {
                margin-left: 16px;
                background: transparent;
                border: none;
                font-size: 14px;
                color: #1890FF;
                outline: none;
                cursor: pointer;

                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }

    .basic-wrap {
        margin-top: 24px;
        padding: 24px;
        border: 1px solid rgba(0, 0, 0, 0.06);

        .img-wrap {
            float: left;
            width: 100px;
            height: 100px;
            border: 1px solid #f0f0f0;

            .img {
                width: 100px;
                height: 100px;
            }
        }

        .basic-info {
            padding-left: 136px;

            .line {
                padding-bottom: 16px;
                font-size: 14px;
                line-height: 22px;

                .lab {
                    color: rgba(0, 0, 0, 0.85);
                }

                .val {
                    color: rgba(0, 0, 0, 0.65);

                    &.tit {
                        display: inline-block;
                        vertical-align: top;
                        width: 720px;
                    }
                }
            }
        }
    }

    .take-order-table {
        &.scroll {
            height: 50vh;
            overflow-y: auto;
            overflow-x: visible;
        }

        .table {
            border: 1px solid #E6E6E6;
            width: 100%;
            min-width: 980px;
            border-spacing: 0;
            border-collapse: collapse;
            font-size: 14px;

            tr {
                height: 50px;
            }

            tr.th {
                background: #fafafa;
            }

            tr th {
                color: rgba(0, 0, 0, 0.85);
                font-weight: normal;
            }

            td {
                border: 1px solid #E6E6E6;
                text-align: center;
                color: rgba(0, 0, 0, 0.85);
            }

            &.min-400 {
                min-width: 400px;
            }
        }

        &.mgt-24 {
            margin-top: 24px;
        }

        &.clearing {
            margin-top: 24px;
        }

        &.clearing tr th {
            border: 1px solid #E6E6E6;
        }

        &.clearing tr th:last-child,
        &.clearing tr td:last-child {
            color: #F81D22;
        }

    }

    .gap-line {
        margin: 40px 0;
        height: 1px;
        background: #E6E6E6;
    }

    .time-line {
        margin-top: 24px;
        list-style: none;

        .item {
            position: relative;

            .item-tail {
                position: absolute;
                top: 6px;
                left: 4px;
                width: 2px;
                height: 100%;
                background: #F7F7F7;
            }

            .item-node {
                position: absolute;
                top: 6px;
                left: 0;
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background: #D9D9D9;
            }

            &:first-child .item-node {
                background: #2A2E3F
            }

            &:last-child .item-tail {
                width: 0;
            }

            .item-content {
                padding-left: 32px;
                font-size: 14px;
                font-weight: 500;
                color: rgba(0, 0, 0, 0.85);
                line-height: 24px;
                padding-bottom: 16px;
            }

            .item-tit {
                padding-bottom: 8px;
            }

            .item-box {
                background: rgba(0, 0, 0, 0.02);
                border-radius: 2px;
                padding: 24px;

                .pdb-12 {
                    padding-bottom: 12px;
                }

                .pdb-6 {
                    padding-bottom: 6px;
                }

                .grey {
                    color: rgba(0, 0, 0, 0.45);
                }

                .green {
                    color: #52C41A
                }

                .blue {
                    color: #1890FF
                }
            }
        }

        .sub-time-line {
            list-style: none;

            .sub-item {
                position: relative;
                padding-left: 24px;

                &::before {
                    content: ' ';
                    position: absolute;
                    top: 15px;
                    left: 3px;
                    width: 1px;
                    height: calc(100% - 12px);
                    background: #D8D8D8;
                }

                &::after {
                    content: ' ';
                    position: absolute;
                    top: 6px;
                    left: 0;
                    width: 7px;
                    height: 7px;
                    border-radius: 50%;
                    background: #fff;
                    border: 1px solid #D8D8D8;
                    box-sizing: border-box;
                }

                &:first-child::after {
                    background: #F81D22;
                    border: 1px solid #F81D22;
                }

                &:last-child::before {
                    width: 0;
                }
            }
        }

    }

    .address-wrap {
        padding-top: 16px;
    }

    .address-label {
        font-size: 14px;
        font-weight: 500;
        color: #666;
        line-height: 30px;
    }

    .address-content {
        padding: 6px 0px;
        color: #333;
        font-size: 13px;

        .line {
            margin-bottom: 6px;

            &:last-child {
                margin-bottom: 0;
            }
        }

        .gap {
            margin-left: 30px;
        }
    }
    
    .newStyle{
        // border:1px solid blue;
        padding:5px 0;
        .bigTitle{font-size:24px;font-weight:bold;color:rgba(0,0,0,0.85);padding:12px 0;}
        .subTitle{font-weight:400;font-size:16px;color:rgba(102,102,102,1);margin-bottom: 20px;}
        .leftBlock{margin-right: 16px;}
        .rightBlock{display: inline-block;vertical-align: top;}
        .time-line .item .item-content{        color:#666;}
    }
    .redNumber{color:#F81D22;padding:0 5px;}
    
    .newBigTitle{font-size:20px;color:rgba(0,0,0,0.85);padding:16px 0;margin-top: 20px;font-weight: bold;}
    .newSubTitle{font-size:13px;color:rgba(102,102,102,1);}
</style>
